import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { Label, makeStyles, tokens } from '@fluentui/react-components';
import classNames from 'classnames';

import { isUnlabelled, TFieldSettings } from '../templateField/fieldSettings';
import { FORM_FIELD_CLASS_NAME } from './constants';
import { getWrappedField } from './formFieldHelpers';

const useStyles = makeStyles({
  // Label and help text are document text, so they keep the document's font.
  label: {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: tokens.fontWeightBold,
  },
});

const FormFieldReadView = ({ node }: NodeViewProps) => {
  const { label, description, required } = (getWrappedField(node, 0)?.node.attrs ?? {}) as Partial<TFieldSettings>;

  const classes = useStyles();
  return (
    <NodeViewWrapper className={classNames(FORM_FIELD_CLASS_NAME, 'my-4')}>
      <div contentEditable={false} className="flex flex-col">
        <Label required={required} className={classes.label}>
          {isUnlabelled(label) ? 'Untitled field' : label}
        </Label>
        {description && <div className="text-[0.9em] text-neutralFg-3">{description}</div>}
      </div>
      <NodeViewContent className="mt-1.5" />
    </NodeViewWrapper>
  );
};

export default FormFieldReadView;
